export default __webpack_public_path__ + "static/banner-one-8d1cc884352b193ebb2cc19e04cbc27c.jpg";